const VALIDATION_ERRORS = {
  INVALID_DESCRIPTION: 'Provide valid description.',
  INVALID_ICON_URL: 'Provide valid icon url.',
  INVALID_TITLE: 'Provide valid title',
  INVALID_COLOR: 'Provide valid color code',
  INVALID_GRADIENT: 'Background gradient requires 2 or 3 colors, each with a valid hex value.',
  GRADIENT_UNSUPPORTED_APP: 'Background gradient is only supported for MSG flags.'
}

const isTitleValid = title => title.length > 0

const isColorObjectValid = (color) => {
  if (!color || typeof color !== 'object') {
    return false
  }

  if (!color.name || typeof color.name !== 'string' || !color.name.trim()) {
    return false
  }

  if (!color.value || typeof color.value !== 'string') {
    return false
  }

  return true
}

const isGradientValid = gradient => {
  if (gradient == null) {
    return true
  }
  if (typeof gradient !== 'object' || !Array.isArray(gradient.stops)) {
    return false
  }
  const { stops } = gradient
  if (stops.length < 2 || stops.length > 3) {
    return false
  }
  return stops.every(isColorObjectValid)
}

export const validateFlag = flag => {
  const { title, color, background_gradient: backgroundGradient, app_name: appName } = flag
  if (!isTitleValid(title)) {
    return { isValid: false, message: VALIDATION_ERRORS.INVALID_TITLE }
  }

  if (!isColorObjectValid(color) && !backgroundGradient) {
    return { isValid: false, message: VALIDATION_ERRORS.INVALID_COLOR }
  }

  if (!isGradientValid(backgroundGradient)) {
    return { isValid: false, message: VALIDATION_ERRORS.INVALID_GRADIENT }
  }

  // Gradient backgrounds are only rendered by the MSG public site (`EventFlag`
  // in `msg-fe-2.0`). ROX and Sphere consumers do not yet read the field, so
  // we reject the combo here as a belt-and-suspenders alongside the UI gate
  // in `FlagBasicInfo` that hides the gradient picker for non-msg apps.
  if (backgroundGradient && appName !== 'msg') {
    return { isValid: false, message: VALIDATION_ERRORS.GRADIENT_UNSUPPORTED_APP }
  }

  return { isValid: true, message: '' }
}
